import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


export default class VoteList {


    constructor() {
        this._init();
    }


    _init() {
        gsap.registerPlugin(ScrollTrigger);

        this.votelists = [...document.querySelectorAll('.js-votelist')];
        this.resultlists = [...document.querySelectorAll('.js-resultlist')];
        this.titles = [...document.querySelectorAll('.js-votelist__title')];
        this._spanwrap();

        this._update();
        window.addEventListener('scroll', this._update.bind(this));

        this._ui();
    }


    /**
     * タイトルをアニメ用のspanで囲む
     */
    _spanwrap() {

        this.titles.forEach($title => {
            const nodes = [...$title.childNodes];
            let str = "";

            nodes.forEach(node => {

                if (node.nodeType == 3) {
                    const text = node.textContent.replace(/\r?\n/g, '');

                    str += text.split('').reduce((acc, v) => {
                        return acc + `<span class="-animestr">${v}</span>`
                    }, '');
                }
                else {
                    str += node.outerHTML;
                }
            });

            $title.innerHTML = str;
        });
    }


    /**
     * スクロールにアニメ
     */
    _update() {

        this.votelists.forEach($votelist => {
            ScrollTrigger.create({
                trigger: $votelist,
                start: "top 70%",
                onEnter: (self) => {
                    if ($votelist.classList.contains('-view')) return;

                    this._setTileAnime($votelist);
                    this._showThumb($votelist);
                    this._showUI($votelist);

                    $votelist.classList.add('-view');
                }
            });
        });

        this.resultlists.forEach($resultlist => {

            ScrollTrigger.create({
                trigger: $resultlist,
                start: "top 70%",
                onEnter: (self) => {
                    if ($resultlist.classList.contains('-view')) return;

                    this._setTileAnimeR($resultlist);
                    this._showThumbR($resultlist);

                    $resultlist.classList.add('-view');
                }
            });
        });
    }


    /**
     * タイトルのアニメ
     */
    _setTileAnime($votelist) {
        const $sholder = $votelist.querySelector('.votelist__sholder');
        if ($sholder) {
            gsap.set($sholder, { opacity: 0 });
            gsap.to($sholder, { duration: 0.35, opacity: 1, ease: 'power2.out' });
        }

        const $texts = [...$votelist.querySelectorAll('.votelist__title .-animestr')];
        $texts.forEach($t => {
            const d = Math.random() * 0.5;
            gsap.set($t, { x: 10, opacity: 0, visibility: 'visible' });
            gsap.to($t, { duration: 0.35, delay: d, x: 0, opacity: 1, ease: 'back.out(1.4)' });
        });
    }

    /**
     * タイトルのアニメ 結果発表版
     */
    _setTileAnimeR($resultlist) {
        const $sholder = $resultlist.querySelector('.resultlist__sholder');
        if ($sholder) {
            gsap.set($sholder, { opacity: 0 });
            gsap.to($sholder, { duration: 0.35, opacity: 1, ease: 'power2.out' });
        }

        const $texts = [...$resultlist.querySelectorAll('.resultlist__title .-animestr')];
        $texts.forEach($t => {
            const d = Math.random() * 0.5;
            gsap.set($t, { x: 10, opacity: 0, visibility: 'visible' });
            gsap.to($t, { duration: 0.35, delay: d, x: 0, opacity: 1, ease: 'back.out(1.4)' });
        });
    }


    /**
     * サムネイル
     */
    _showThumb($votelist) {
        const $thumbs = [...$votelist.querySelectorAll('.votelist__item')];
        const vects = ['lr', 'rl', 'tb', 'bt'];

        $thumbs.forEach($t => {
            const d = (Math.random() * 0.5) * 1000 + 500;

            setTimeout(() => {
                const v = vects[Math.floor(Math.random() * vects.length)];
                const $color = $t.querySelector('.-color');
                $color.setAttribute('data-vect', v);
                gsap.set($color, { visibility: 'visible' });

                $t.classList.add('-view');
            }, d);
        });
    }


    /**
    * サムネイル 結果発表版
    */
    _showThumbR($resultlist) {
        const $thumbs = [...$resultlist.querySelectorAll('.resultlist__item')];
        const vects = ['lr', 'rl', 'tb', 'bt'];

        $thumbs.forEach($t => {
            const d = (Math.random() * 0.5) * 1000 + 500;

            setTimeout(() => {
                const v = vects[Math.floor(Math.random() * vects.length)];
                const $color = $t.querySelector('.-color');
                $color.setAttribute('data-vect', v);
                gsap.set($color, { visibility: 'visible' });

                $t.classList.add('-view');
            }, d);
        });
    }


    /**
     * UI表示
     */
    _showUI($votelist) {
        const $ui = $votelist.querySelector('.votelist__ui');
        gsap.set($ui, { visibility: 'visible', opacity: 0 });
        gsap.to($ui, { duration: 0.35, opacity: 1, ease: 'power2.out' });
    }


    /**
     * UIのセット
     */
    _ui() {

        this.votelists.forEach($votelist => {
            const $main = $votelist.querySelector('.votelist__main');
            const $prev = $votelist.querySelector('.votelist__ui__item.-prev');
            const $next = $votelist.querySelector('.votelist__ui__item.-next');

            $prev.addEventListener('click', () => {
                const moveval = this._getThumbSize($votelist);
                const sl = $main.scrollLeft;
                gsap.to($main, { duration: 0.7, scrollLeft: sl - moveval, ease: 'power2.out' });
            });

            $next.addEventListener('click', () => {
                const moveval = this._getThumbSize($votelist);
                const sl = $main.scrollLeft;
                gsap.to($main, { duration: 0.7, scrollLeft: sl + moveval, ease: 'power2.out' });
            });
        });
    }


    _getThumbSize($votelist) {
        const $thumb = [...document.querySelectorAll('.votelist__item')][0];
        return $thumb.getBoundingClientRect().width;
    }
}
